// 类型定义
interface StorageInterface {
  getItem(key: string): any;
  setItem(key: string, value: any): void;
  clear(keepDataKeys?: string[]): void;
}

let myStorage: Record<string, any> = {};

class MyStorage implements StorageInterface {
  private sysStore: Storage | null = null;

  private _isSupportLocalStorage(storage: Storage): boolean {
    const mod = "modernizr";
    try {
      storage.setItem(mod, mod);
      storage.removeItem(mod);
      return true;
    } catch {
      return false;
    }
  }

  constructor(sessionMode: boolean = false) {
    if (!sessionMode && this._isSupportLocalStorage(window.localStorage)) {
      this.sysStore = window.localStorage;
    } else if (this._isSupportLocalStorage(window.sessionStorage)) {
      this.sysStore = window.sessionStorage;
    }
  }

  getItem(key: string): any {
    if (this.sysStore) {
      try {
        let s = this.sysStore.getItem(key);
        if (!s) return null;
        s = JSON.parse(s);
        return s;
      } catch {
        return null;
      }
    }
    return myStorage[key];
  }

  setItem(key: string, value: any): void {
    if (this.sysStore) {
      try {
        this.sysStore.setItem(key, JSON.stringify(value));
      } catch {
        // 忽略错误
      }
      return;
    }
    myStorage[key] = value;
  }

  clear(keepDataKeys?: string[]): void {
    if (this.sysStore) {
      try {
        if (keepDataKeys && keepDataKeys.length) {
          const keepData: Record<string, string> = {};

          const allKeys = Object.keys(this.sysStore);

          allKeys.forEach(storageKey => {
            const shouldKeep = keepDataKeys.some(keepKey => {
              if (keepKey.endsWith(":")) {
                return storageKey.startsWith(keepKey);
              }
              return storageKey === keepKey;
            });

            if (shouldKeep) {
              const value = this.sysStore!.getItem(storageKey);
              if (value) {
                keepData[storageKey] = value;
              }
            }
          });

          this.sysStore.clear();
          for (const key in keepData) {
            this.sysStore.setItem(key, keepData[key]);
          }
        } else {
          this.sysStore.clear();
        }
      } catch {
        // 忽略错误
      }
      return;
    }
    myStorage = {};
  }
}

export const storage = new MyStorage(false);
export const seStorage = new MyStorage(true);
